import { Component, OnInit } from '@angular/core';
import { Payment } from '../payment';
import { PaymentService } from '../payment.service';

import { Location } from '@angular/common';

import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';
import { PoService } from '../../po/po.service';
import { ActivatedRoute, Params } from '@angular/router';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { DatepickerOptions } from 'ng2-datepicker';
import { Po } from 'client/app/po/po';

@Component({
  selector: 'app-create-payment',
  templateUrl: './create-payment.component.html',
  styleUrls: ['./create-payment.component.css']
})
export class CreatePaymentComponent implements OnInit {

  public dateOptions: DatepickerOptions = {
    //this.dateOptions = {
      minYear: 1999,
      maxYear: 2030,
	 
      displayFormat: 'MMM D[,] YYYY',
      barTitleFormat: 'MMMM YYYY',
      dayNamesFormat: 'dd',
      firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
      minDate: new Date(Date.now()), // Minimal selectable date
      maxDate: new Date(Date.now()),  // Maximal selectable date
	  
      barTitleIfEmpty: 'Click to select a date',
      placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
     // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
      addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
      fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
      useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
    };

  payment = new Payment();
  paymentdata : any = {}
  invoices: Invoice[];
  submitted = false;
  message: string;
  purchaseorders :any = [];
  
  invoicebyPO: any = [];
  paymentForm: FormGroup;
  public isupdate = false;
  public FormName = "Add a Payment";
  po = new Po();  

  constructor(
    private paymentService: PaymentService,
    private invoiceService: InvoiceService,
    private poService: PoService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    private router: Router,
    private location: Location,
    private auth: AuthService,
  ) { }

  ngOnInit() {
    this.payment.active = 1;
    //this.submitted = true;
    this.GetPOforInvoice();
    
    // stop here if form is invalid
    if(this.route.snapshot.paramMap.get('paymentid') != null)
			{
        const paymentId = +this.route.snapshot.paramMap.get('paymentid');
				 if(paymentId > 0)
				 {
					 this.getPayment(paymentId);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Payment";
				 
			}
    this.paymentForm = this.formBuilder.group({			
      poreferenceid: [this.payment.poreferenceid,[Validators.required, Validators.required]],
      paymentMode: [this.payment.paymentMode,[Validators.required, Validators.required]],
      paymentreferenceno: [this.payment.paymentreferenceno,[Validators.required, Validators.required]],
      paymentdate: [this.payment.paymentdate,[Validators.required, Validators.required]],
      amount: [this.payment.amount,[Validators.required, Validators.required]],
      active: [this.payment.active,[Validators.required, Validators.required]]
    });	
  }

  get f() {
    return this.paymentForm.controls
    }
  
    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.paymentForm.invalid) {
          return this.util.showError("Please enter required fields.");		
      }
    else{
      if(this.isupdate){
        this.updatePayment();
      }
      else{
        this.addPayment();
      }
    }
  }

  public addPayment() {
    this.save();
  }
  public updatePayment() {
    this.update();
  }

  //  private save(): void {
	//   this.paymentdata = this.payment;
  //   var date = new Date(this.payment.paymentdate);
  //   var newdate = new Date(date);
  //   //this.paymentdata.paymentdate = newdate.setDate(newdate.getDate() + 1);
  //   this.paymentdata.createdby = this.auth.currentUserValue.userid

  //   this.paymentService.addPayment(this.paymentdata).subscribe(
  //     (data :any) => {
  //       if(data.paymentid >0){
        
  //       this.util.showSuccess("Payment added successfully");
  //       this.router.navigate(['/payment-list']);//for Redirecting to the list view     
  //       }
  //     });
       
  // }

  private save(): void {
    this.paymentdata = this.payment;
    var date = new Date(this.payment.paymentdate);
    var newdate = new Date(date);
     this.paymentdata.createdby = this.auth.currentUserValue.userid
    this.paymentService.addPayment(this.paymentdata).subscribe(() => 
    { 
    this.util.showSuccess("Payment added successfully.");
    this.router.navigate(['/payment-list']);
    });
    // this.goBack();  //for Redirecting to the list view     
  }
  
  update(): void {
    //this.submitted = true;
    this.submitted = true;
    this.paymentdata = this.payment;
    this.paymentdata.modifiedby = this.auth.currentUserValue.userid;
    this.paymentdata.modifiedon = Date.now();
    this.paymentService.updatePayment(this.paymentdata)
        .subscribe(() => 
      { 
      this.util.showSuccess("Payment update successfully.");
        this.router.navigate(['/payment-list']);
      });
  }

  // updatePayment(){

  // }
  getPayment(paymentid) {
    return this.paymentService.GetPaymentDetails(paymentid)
               .subscribe(
                payment => {
                  console.log(payment);
                  this.payment = payment
                  //this.getCityByState(this.vendor.stateid);
                 }
                );
  }

  
 GetPOforInvoice() {
  return this.poService.GetPOforPayment()
             .subscribe(
              purchaseorders => {              
                this.purchaseorders = purchaseorders 
               }
              );
}

onPoChangeObj(poid){
	
  // console.log(this.purchaseorders.filter(items => items.poid == poid)[0].podate);
  this.dateOptions.minDate = new Date(this.purchaseorders.filter(items => items.poid == poid)[0].podate);
  this.GetInvoiceByPO(poid);
  
}

GetInvoiceByPO(poid){
  return this.paymentService.GetInvoiceByPO(poid)
             .subscribe(
              invoicebyPO => {              
                this.invoicebyPO = invoicebyPO 
               }
              );
}

}
